// Setup → Agency's Agency cash panel (finance redesign slice 4, J18, TD-077): the agency's cash on a date, which /finance's
// Cash counts from. Not the bank's balance: the account can hold money that is not the agency's, so the owner enters the
// agency's part. A WorkspacePanel like every Setup panel (DD-002, DD-047). Its one action is a PanelHeaderAction (DD-005)
// that opens the drawer setting it (DD-051).
import { EditIcon } from "@/components/icons";
import { MoneyText } from "@/components/ui/MoneyText";
import { PanelHeaderAction } from "@/components/ui/PanelHeaderAction";
import { ENTITY_CONFIG } from "@/core/entityConfig";
import { WorkspacePanel } from "@/domains/Ideas/components/WorkspacePanel";
import { useAgencyCashFigure } from "../hooks/useAgencyFinance";
import { dateLabel } from "../utils/format";
import { AGENCY_CASH_HINT } from "./cashText";

const OWNER = `${ENTITY_CONFIG.finance.label}'s Cash`;

export function AgencyCashCard({ onEdit }: { onEdit: () => void }) {
  const query = useAgencyCashFigure();
  const figure = query.data?.agencyCash ?? null;
  return (
    <WorkspacePanel
      title="Agency cash"
      collapsed={false}
      loading={query.isLoading}
      className="h-full"
      actions={<PanelHeaderAction label={figure ? "Change" : "Set"} icon={<EditIcon className="w-4 h-4" />} onClick={onEdit} disabled={!query.data} />}
    >
      <div className="space-y-2 text-sm">
        {query.isError && <p className="text-red-600">Could not load the agency's cash.</p>}
        {figure && (
          <div>
            <p className="text-xs text-gray-500">{`Agency cash on ${dateLabel(figure.asOf)}`}</p>
            <p className="mt-1 text-xl">
              <MoneyText amountMinor={figure.amountMinor} strong balance />
            </p>
          </div>
        )}
        {query.data && !figure && <p className="text-gray-600">{`None yet. ${OWNER} counts from the books' cash until it is set.`}</p>}
        <p className="text-xs text-gray-500">{`${AGENCY_CASH_HINT} ${OWNER} counts from it, plus everything paid in and out after its day.`}</p>
      </div>
    </WorkspacePanel>
  );
}
